import { Avatar } from "@material-ui/core";
import { CSSProperties } from "@material-ui/styles";
import React, { useMemo } from "react";
import { getCombustivelDefBySigla } from "../models/combustivel";

export interface AvatarCombustivelProps {
  combustivelSigla: string;
  size?: "small" | "smallest";
  style?: CSSProperties;
}

export function AvatarCombustivel(props: AvatarCombustivelProps) {
  const combMemo = useMemo(() => getCombustivelDefBySigla(props.combustivelSigla), [props.combustivelSigla]);

  const styleNormal = props.combustivelSigla?.length > 3 ? { fontSize: '0.9rem' } : { fontSize: '1.25rem' };
  const styleSmall = props.combustivelSigla?.length > 3 ? { fontSize: '0.6rem', width: '27px', height: '27px' } : { fontSize: '0.75rem', width: '27px', height: '27px' };
  const styleSmallest = { width: '12px', height: '12px' }
  const styleSize = props.size === "small" ? styleSmall : props.size === "smallest" ? styleSmallest : styleNormal;
  const style = props.style ? { ...props.style, ...styleSize } : styleSize;

  return <Avatar variant="rounded" style={{ backgroundColor: combMemo?.cor, ...style }}>
    {props.size !== "smallest" ? props.combustivelSigla : ""}
  </Avatar>;
}